module.exports = __webpack_public_path__ + "fonts/manrope-regular.a4ccea7d.woff2";